module.exports = __webpack_public_path__ + "img/thumb_aula22.69abd5c1.jpg";